<div [class.sk-page]="!embedded" [class.uebersicht-embedded]="embedded">

  <!-- Hero (nur eigenständig, nicht als Tab) -->
  <div class="sk-hero" *ngIf="!embedded">
    <div class="sk-hero-info">
      <h1><mat-icon class="hero-title-icon">insights</mat-icon> Meine Projekte</h1>
      <div class="sk-hero-sub">
        <span><mat-icon class="sk-inline-icon">folder_open</mat-icon>{{ projectCount }} Projekt(e)</span>
        <span *ngIf="projectsNeedingAction > 0">
          <mat-icon class="sk-inline-icon">notification_important</mat-icon>{{ projectsNeedingAction }} mit Freigabe-Bedarf
        </span>
      </div>
    </div>
  </div>

  <!-- Kennzahlen -->
  <div class="sk-stats">
    <div class="sk-stat">
      <div class="sk-stat-icon"><mat-icon>folder_open</mat-icon></div>
      <div>
        <div class="sk-stat-value">{{ projectCount }}</div>
        <div class="sk-stat-label">Projekte</div>
      </div>
    </div>
    <div class="sk-stat">
      <div class="sk-stat-icon"><mat-icon>schedule</mat-icon></div>
      <div>
        <div class="sk-stat-value">{{ totalHours }} h</div>
        <div class="sk-stat-label">Stunden gesamt</div>
      </div>
    </div>
    <div class="sk-stat" [class.alert]="hoursToApproveCount > 0">
      <div class="sk-stat-icon tone-orange"><mat-icon>pending_actions</mat-icon></div>
      <div>
        <div class="sk-stat-value">{{ hoursToApprove }} h</div>
        <div class="sk-stat-label">Stunden zur Freigabe ({{ hoursToApproveCount }})</div>
      </div>
    </div>
    <div class="sk-stat" [class.alert]="materialToApprove > 0">
      <div class="sk-stat-icon tone-brown"><mat-icon>handyman</mat-icon></div>
      <div>
        <div class="sk-stat-value">{{ materialToApprove }}</div>
        <div class="sk-stat-label">Material zur Freigabe</div>
      </div>
    </div>
  </div>

  <!-- Kunden-Filter (nur im Gesamt-Modus, nicht wenn auf einen Kunden begrenzt) -->
  <div class="sk-filter-chips cust-chips" *ngIf="!fixedCustomer && customers.length > 1">
    <button class="sk-filter-chip" [class.active]="selectedCustomerId === null" (click)="selectCustomer(null)">
      Alle Kunden
    </button>
    <button class="sk-filter-chip" *ngFor="let c of customers"
            [class.active]="selectedCustomerId === c.id" (click)="selectCustomer(c.id)">
      {{ c.name }}
    </button>
  </div>

  <!-- Ansicht umschalten -->
  <div class="sk-filter-chips view-chips">
    <button class="sk-filter-chip" [class.active]="view === 'projekte'" (click)="view = 'projekte'">
      <mat-icon class="sk-inline-icon">dashboard</mat-icon> Projekte
    </button>
    <button class="sk-filter-chip" [class.active]="view === 'personen'" (click)="view = 'personen'">
      <mat-icon class="sk-inline-icon">groups</mat-icon> Nach Personen
    </button>
  </div>

  <!-- Leerzustand -->
  <div class="sk-empty" *ngIf="!loading && projects.length === 0">
    <div class="sk-empty-icon"><mat-icon>insights</mat-icon></div>
    <p>Noch keine Projekte mit Aktivität.<br>
      <span class="sk-muted">Sobald Einsätze geplant und Stunden erfasst werden, erscheinen deine Projekte hier.</span>
    </p>
  </div>

  <!-- Projekte -->
  <div class="projects" *ngIf="view === 'projekte' && projects.length > 0">
    <div class="sk-card project-card" [class.action]="needsAction(p)"
         *ngFor="let p of projects; trackBy: trackByAuftrag" (click)="openDetail(p)">
      <div class="pc-head">
        <div class="pc-title">
          <strong>{{ p.title }}</strong>
          <span class="pc-customer sk-muted">{{ p.customerName }}</span>
        </div>
        <span class="status-chip" [attr.data-status]="p.status">{{ statusLabels[p.status] }}</span>
      </div>

      <div class="pc-metrics">
        <div class="metric">
          <span class="metric-value">{{ p.totalHours }} h</span>
          <span class="metric-label">Stunden</span>
        </div>
        <div class="metric">
          <span class="metric-value">{{ p.assignmentCount }}</span>
          <span class="metric-label">Einsätze</span>
        </div>
        <div class="metric">
          <span class="metric-value">{{ p.materialTotalCount }}</span>
          <span class="metric-label">Materialposten</span>
        </div>
      </div>

      <!-- Freigabe-Aktionen -->
      <div class="pc-actions" *ngIf="needsAction(p)">
        <button mat-raised-button color="primary" *ngIf="p.submittedHourCount > 0"
                [disabled]="busyAuftragId === p.auftragId" (click)="approveHours(p, $event)">
          <mat-icon>done_all</mat-icon> {{ p.submittedHours }} h freigeben ({{ p.submittedHourCount }})
        </button>
        <button mat-stroked-button color="primary" *ngIf="p.materialSubmittedCount > 0"
                [disabled]="busyAuftragId === p.auftragId" (click)="approveMaterials(p, $event)">
          <mat-icon>handyman</mat-icon> {{ p.materialSubmittedCount }} Material freigeben
        </button>
      </div>
      <div class="pc-clear" *ngIf="!needsAction(p) && p.hourEntryCount > 0">
        <mat-icon class="sk-inline-icon">check_circle</mat-icon> Alles freigegeben
      </div>

      <div class="pc-foot sk-muted">
        <span>Details ansehen</span>
        <mat-icon class="sk-inline-icon">chevron_right</mat-icon>
      </div>
    </div>
  </div>

  <!-- Nach Personen -->
  <div class="persons" *ngIf="view === 'personen' && projects.length > 0">
    <div class="sk-empty" *ngIf="persons.length === 0">
      <div class="sk-empty-icon"><mat-icon>groups</mat-icon></div>
      <p>Noch keine erfassten Stunden.</p>
    </div>

    <div class="sk-card persons-card" *ngIf="persons.length > 0">
      <div class="persons-head">
        <mat-icon>groups</mat-icon>
        <strong>Stunden je Person</strong>
        <span class="sk-spacer"></span>
        <span class="persons-total">{{ personsTotalHours }} h gesamt</span>
      </div>
      <div class="person-line" *ngFor="let p of persons; trackBy: trackByPerson">
        <div class="person-main">
          <span class="person-name">{{ personLabel(p) }}</span>
          <div class="person-bar-track"><div class="person-bar" [style.width.%]="personBar(p)"></div></div>
        </div>
        <div class="person-hours">
          <span class="ph-total">{{ p.totalHours }} h</span>
          <span class="ph-split sk-muted">
            <span class="ph-approved" *ngIf="p.approvedHours > 0" matTooltip="freigegeben">{{ p.approvedHours }} h frei</span>
            <span class="ph-open" *ngIf="p.submittedHours > 0" matTooltip="offen/zur Freigabe">{{ p.submittedHours }} h offen</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="sk-loading" *ngIf="loading">
  <mat-spinner diameter="42"></mat-spinner>
</div>
